<template>
  <div class="topmunu">
    <div class="left">
      <img :src="titleimg" />
      
      <!-- <p>{{titleName}}</p> -->
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      isactive: 0,
      titleName: "",
      titleimg: "",
    };
  },
  watch: {
    $route(to, from) {
      // console.log(to.path);
      if (to.path == "/achievementMsg") {
        this.titleimg = require("../assets/chengjilogo.png");
        this.titleName = "成绩查询";
      } else if (to.path == "/historyMsg" || to.path == "/sbchistoryMsg" ||to.path ==  "/sbchistoryIndex" ) {
        this.titleimg = require("../assets/linianlogo.png");
        this.titleName = "历年录取信息查询";
      } else if (to.path == "/enrollmentResult") {
        this.titleimg = require("../assets/luqulogo.png");
        this.titleName = "录取结果信息查询";
      }
      
    },
  },
  methods: {
  },
  mounted() {
    // console.log(this.$route.path);

    if (this.$route.path == "/achievementMsg") {
      this.titleimg = require("../assets/chengjilogo.png");
      this.titleName = "成绩查询";
    } else if (this.$route.path == "/historyMsg" || this.$route.path == "/sbchistoryMsg" || this.$route.path == "/sbchistoryIndex") {
      this.titleimg = require("../assets/linianlogo.png");
      this.titleName = "历年录取信息查询";
    } else if (this.$route.path == "/enrollmentResult") {
      this.titleimg = require("../assets/luqulogo.png");
      this.titleName = "录取结果信息查询";
    }
  },
};
</script>
<style scoped>
.topmunu {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #f1f1f1;
  background: white;
  padding: 10px 0;
}
.left {
  float: left;
  padding-left: 20px;
}
.left img {
  height: 48px;
  width: auto;
}
.left p {
  display: inline-block;
  position: relative;
  left: 40px;
  top: -20px;
  font-size: 22px;
  font-weight: 700;
}
.center {
  float: left;
  position: relative;
  left: 24%;
  top: -10px;
}
ul li {
  list-style: none;
  padding: 28px 40px;
  /* margin: auto; */
  /* border-bottom: 1px solid #f1f1f1; */
  cursor: pointer;
  /* display: inline-block; */
  float: left;
  font-size: 20px;
}
li:hover {
  background: #f7f7f7;
}
ul {
  padding: 0px;
  margin: 0px;
  text-align: center;
}
.title {
  color: #2d76f9;
  font-weight: 600;
}
.active {
  /* background: #f9f9f9; */
  color: #2d76f9;
  border-bottom: 2px solid #2d76f9;
}
</style>